/* eslint-disable import/named */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Table as AntTable } from 'antd';
import './styles.css';
import { withTableSkeleton } from './withTableSkeleton';
import withColumnPicker from './withColumnPicker';

const TableOnly = ({
  columns,
  rowKey,
  data = [],
  rowSelection,
  rowClassName,
  size = 'medium',
  extraClass = '',
  pagination = false,
  hideOnSinglePage = false,
  showColumnPicker = false,
  hiddenColumns = [],
  emptyColumnName,
  disabledColumns,
  onChange,
  ...rest
}) => {

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (onChange) {
      onChange(pagination, filters, sorter, extra);
    }
  };

  return (
      <AntTable
        pagination={pagination}
        hideOnSinglePage={hideOnSinglePage}
        columns={columns}
        rowSelection={rowSelection}
        dataSource={data}
        rowKey={rowKey}
        size={size}
        rowClassName={rowClassName}
        className={extraClass}
        onChange={handleTableChange}
        {...rest}
      />
  );
};

export const Table = withColumnPicker(withTableSkeleton(TableOnly));
